import React, { forwardRef, useMemo } from 'react';
import { flatten } from '../utils/object';

const GettingStartedPlanForm = ({ action, token, values, children }, ref) => {
  const fields = useMemo(
    () => {
      const {
        questionnaire: { packages: packagesValues, address, rooms },
      } = values;
      const packages = Object.keys(packagesValues).reduce((acct, key) => {
        const actualKey = key
          .split('_')
          .slice(0, -1)
          .join('_');
        return {
          ...acct,
          [actualKey]: [...(acct[actualKey] || []), packagesValues[key]],
        };
      }, {});
      const roomsFields = rooms.reduce(
        (acct, room) => ({
          ...acct,
          [room.type]: room.quantity,
        }),
        {},
      );
      const flattenObject = flatten({
        questionnaire: { packages, ...address, rooms: roomsFields },
      });
      return Object.keys(flattenObject).reduce(
        (acct, key) => [...acct, { name: key, value: flattenObject[key] }],
        [],
      );
    },
    [values],
  );

  return (
    <form ref={ref} action={action} method="POST">
      <input type="hidden" name="authenticity_token" value={token} />
      {fields.map((field, index) => (
        <input
          key={`${field.name}${field.value}${index}`}
          type="hidden"
          name={field.name}
          value={field.value}
        />
      ))}
      {children}
    </form>
  );
};

export default forwardRef(GettingStartedPlanForm);



// WEBPACK FOOTER //
// ./app/javascript/components/getting_started/components/GettingStartedPlanForm.js